import feathers from '@feathersjs/client'
import socketio from '@feathersjs/socketio-client'
import fcAuth from '@feathersjs/authentication-client'
import io from 'socket.io-client/dist/socket.io'
import { invalidateQuery } from './QueryCache'

// const isDev = !(window._env_ && window._env_.NODE_ENV && window._env_.NODE_ENV === 'production')
const API_BASE_URL = window?._env_?.API_BASE_URL ? window._env_.API_BASE_URL : 'http://localhost:3000'

const FC = {
  socketConfig: {
    timeout: 90000,
    pingInterval: 5000,
    pingTimeout: 20000
  },
  socket: io(API_BASE_URL),
  client: feathers(),
  authenticated: false,
  online: false,
  isDev: true,
  connectionHandler: (event) => () => {
    FC.isDev && console.log(`Socket ${event} to ${API_BASE_URL}`)
    FC.online = event === 'connect'
  },
  clientStatus: 'NO'
}

FC.client.configure(socketio(FC.socket, FC.socketConfig))
FC.client.configure(fcAuth({ storage: new fcAuth.MemoryStorage() }))
FC.socket.on('connect', FC.connectionHandler('connect'))
FC.socket.on('disconnect', FC.connectionHandler('disconnect'))

FC.addListeners = () => {
  FC.isDev && console.log('FC Authenticated & Listening for events')
  /* FC.client.service('clients').on('created', updateClientStatus) */
  // FC.client.service('processes').on('created', async () => { invalidateQuery('processes') })
  FC.client.service('clients').on('patched', async () => { invalidateQuery('clients'); invalidateQuery('clientsByAgency') })
}

FC.stopListeners = () => {
  FC.isDev && console.log('FC Stopped listening for events')
  FC.client.service('clients').removeListener('patched')
}

FC.login = async (credentials) => {
  try {
    const response = await FC.client.authenticate(credentials)
    FC.authenticated = !!response.accessToken
    FC.authenticated && FC.addListeners()
    return response
  } catch (details) {
    FC.error = details
    return false
  }
}

FC.logout = async () => {
  FC.stopListeners()
  FC.client.logout()
  FC.authenticated = false
}

FC.service = (...params) => FC.client.service(...params)

/** Ripristino log via REST (evita timeout socket ~90s su archivi grandi). */
FC.restoreLogsFromArchives = async (filenames) => {
  const token = await FC.client.authentication.getAccessToken()
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 10 * 60 * 1000)
  try {
    const res = await fetch(`${API_BASE_URL}/restored-logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : ''
      },
      body: JSON.stringify({ filenames }),
      signal: controller.signal
    })
    const data = await res.json().catch(() => ({}))
    if (!res.ok) {
      throw new Error(data?.message || data?.error || res.statusText || 'Ripristino fallito')
    }
    return data
  } catch (err) {
    if (err?.name === 'AbortError') {
      throw new Error('Timeout: il ripristino ha superato i 10 minuti.')
    }
    throw err
  } finally {
    clearTimeout(timeoutId)
  }
}

FC.isReady = () => FC.online && FC.authenticated
export { FC }
